import React, { useEffect, useState, useContext, useCallback } from "react";
import { POKTOOLS_API_URL } from "./PoktoolsVariables";
import "./Poktools.scss";
import { PoktoolsContext } from "./poktoolsContext";
import { POKTOOLS_ACTIONS } from "./poktoolsReducer";
import axios from "axios";
import FastPok from "./fastpok/FastPok";
import Trainer from "./trainer/Trainer";
import RiskPremium from "./riskpremium/RiskPremium";
import PoktoolsHome from "./home/PoktoolsHome";
import { Route } from "react-router-dom";
import { Switch } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function Poktools(props) {
  const [licenseDate, setLicenseDate] = useState(null);
  const [titanName, setTitanName] = useState("home");
  const { poktoolsState, dispatchPoktoolsState } = useContext(PoktoolsContext);

  if (!window.poktoolsLastUrls) {
    window.poktoolsLastUrls = {
      home: "home",
      trainer: "trainer/1/exp/openpush",
      fastpok: "fastpok/form/open_push/6/-1/CO/20/12.5",
      rp: "rp/form"
    };
  }

  const { t } = useTranslation();

  const showError = useCallback(
    (message) =>
    {
      console.error("error", message);
      if (message!== "ERR_INVALID_LICENCE")
      {
        toast.error(t("poktools.error") + " : " + message, {
          position: "bottom-right",
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: 0
        });
        
      }
    },
    [t]
  );

  const requestToken = useCallback(() => {
    //console.log("requesting token");
    axios({
      method: "post",
      headers: {
        "X-USER-POKTOOLS": poktoolsState.xUserPoktools,
        "X-PARTNER-POKTOOLS": poktoolsState.xPartnerPoktools,
        "x-xeester-licence": poktoolsState.xXeesterLicence,
        Accept: "*/*",
        "content-type": "application/x-www-form-urlencoded"
      },
      mode: "cors",
      url: POKTOOLS_API_URL + "renew"
    })
      .then((resp) => {
        console.info("resp", resp.data);
        if (resp.data.errorCode) {
          showError(resp.data.errorCode);
        } else {
          dispatchPoktoolsState({
            type: POKTOOLS_ACTIONS.TOKEN_UPDATED,
            payload: resp.data.token
          });
        }
      })
      .catch((err) => {
        console.error("fetch problem", err);
        showError("FETCH");
      });
  }, [
    dispatchPoktoolsState,
    poktoolsState.xPartnerPoktools,
    poktoolsState.xUserPoktools,
    poktoolsState.xXeesterLicence,
    showError
  ]);

  const requestLicence = useCallback(() => {
    //console.log("requesting token");
    //dispatchLoading({ type: "update", payload: 10 });
    axios({
      method: "post",
      headers: {
        "X-USER-POKTOOLS": poktoolsState.xUserPoktools,
        "X-PARTNER-POKTOOLS": poktoolsState.xPartnerPoktools,
        "x-xeester-licence": poktoolsState.xXeesterLicence,
        Accept: "*/*",
        "content-type": "application/x-www-form-urlencoded"
      },
      mode: "cors",
      url: POKTOOLS_API_URL + "checklicence"
    })
      .then((resp) => {
        if (resp.data.errorCode) {
          showError(resp.data.errorCode);
        } else {
          console.log("date", resp.data.licenceCreatedAt);
          setLicenseDate((l) => Date.parse(resp.data.licenceCreatedAt));
          console.log("date", Date.parse(resp.data.licenceCreatedAt));
        }
      })
      .catch((err) => {
        console.error("fetch problem", err);
        //showError("FETCH");
      });
  }, [
    poktoolsState.xPartnerPoktools,
    poktoolsState.xUserPoktools,
    poktoolsState.xXeesterLicence,
    showError
  ]);
  useEffect(() => {
    if (titanName !== props.match.params.tool) {
      setTitanName((t) => props.match.params.tool);
    }
    let urls = {
      home: window.poktoolsLastUrls.home,
      trainer: window.poktoolsLastUrls.trainer,
      fastpok: window.poktoolsLastUrls.fastpok,
      rp: window.poktoolsLastUrls.rp
    };
    urls[props.match.params.tool] = document.location.href.substring(
      document.location.href.indexOf("/app/poktools/")+ 14
    );
    console.log("changed url:" + urls[props.match.params.tool]);
    window.poktoolsLastUrls = urls;

    let interval;

//    axios.get("http://localhost:8099/api/poktools/hasValidLicence").then((response)=>{
    if (window.bridge)
    {
      let licence = window.bridge.hasValidLicence();
      if (!licenseDate)
      {
        if (!poktoolsState.xUserPoktools)
        {
          //          axios.get("http://localhost:8099/api/poktools/getCrypt").then((response)=>{
          let crypt = window.bridge.getCrypt();
          //console.log("crypt:" + crypt);
          dispatchPoktoolsState({
            type: POKTOOLS_ACTIONS.USER_UPDATED,
            payload: crypt
          });
          //          });
        } else
        {
          requestLicence();
        }
      } else
      {
        console.log("licenseDate set", licenseDate);
        requestToken();
        let now = Date.now();
        let end = licenseDate + 7 * 24 * 60 * 60 * 1000;
        let diff = end - now;
        dispatchPoktoolsState({
          type: POKTOOLS_ACTIONS.LICENCE_UPDATED,
          payload: {
            licence: licence,
            licenseDate: licenseDate,
            remainingTime: diff
          }
        });
        interval = setInterval(() =>
        {
          if (licenseDate)
          {
            let now = Date.now();
            let end = licenseDate + 7 * 24 * 60 * 60 * 1000;
            let diff = end - now;
            //axios.get("http://localhost:8099/api/poktools/hasValidLicence").then((response)=>{
            let licence = window.bridge.hasValidLicence();
            dispatchPoktoolsState({
              type: POKTOOLS_ACTIONS.LICENCE_UPDATED,
              payload: {
                licence: licence,
                licenseDate: licenseDate,
                remainingTime: diff
              }
            });
            if (licence === 0 && diff < 0)
            {
              props.history.push("/app/poktools/home");
            }
            //});
            //console.log("diff", diff);
          }
        }, 1000 * 3600);
      }
    }
    //});

    return () => {
      if(interval){
        clearInterval(interval);
      }
    };
  }, [
    dispatchPoktoolsState,
    licenseDate,
    poktoolsState.xUserPoktools,
    props.match.params.tool,
    titanName,
    requestLicence,
    props.history,
    requestToken
  ]);

  return (
    <div className="poktools">
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
      />
      <div className="tabs">
        <Switch>
          <Route
            path="/app/poktools/home"
            exact
            render={(props) => <PoktoolsHome {...props}></PoktoolsHome>}
          />
          <Route
            path="/app/poktools/fastpok/:tab/:situation/:players/:positionVilain/:positionHero/:stack/:ante"
            exact
            render={(props) => <FastPok {...props}></FastPok>}
          />
          <Route
            path="/app/poktools/trainer/:level/:game/:situation"
            exact
            render={(props) => <Trainer {...props}></Trainer>}
          />
          <Route
            path="/app/poktools/rp/:tab"
            exact
            render={(props) => <RiskPremium {...props}></RiskPremium>}
          />
        </Switch>
      </div>
    </div>
  );
}
export default Poktools;
